export default function CareInstruction({ CareInstructionItem }) {
    if (!CareInstructionItem) return null;
    return (
        <><h2 className="tab-section-txt">CARE INSTRUCTIONS:</h2>
            <ul className="section_care">
                <li>Vacuum regularly (avoid beater bar)</li>
                <li>Spot clean with mild detergent and water</li>
                <li>Avoid soaking for excessive moisture</li>
                <li>Rotate every few months for even wear</li>
                <li>Safe for homes with children and pets</li>
            </ul></>
    )
}